import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App.tsx'
import { ToastProvider } from './components/Toast.tsx'
import { ConfirmProvider } from './components/Confirm.tsx'
// The ported V1 design system. `styles.css` is what remains of the app's
// original hand-written stylesheet and shrinks to nothing as each screen moves
// across -- it is loaded second so a ported screen is never fighting it.
import './theme.css'
import './styles.css'

const root = document.getElementById('root')
if (root === null) throw new Error('no #root element')

createRoot(root).render(
  <StrictMode>
    {/* Outside App so every screen and modal can toast, including the ones
        rendered above the router. */}
    <ToastProvider>
      <ConfirmProvider>
        <App />
      </ConfirmProvider>
    </ToastProvider>
  </StrictMode>,
)
